import {loadable} from 'router/routes';

const Logout = loadable(() => import('./Logout'));

export default Logout;
